// TODO: Добавить типизацию
export const checkAlwaysAvailableRoute = (to: any): boolean => to.meta.middleware?.alwaysAvailable ?? false;

export const handleAlwaysAvailableRoute = (to: any, next: Function): boolean => {
  if (checkAlwaysAvailableRoute(to)) {
    next();
    return true;
  }
  return false;
};